import { FormikContextType, getIn } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { IQuestion } from 'types/Question.types';
import { isAnswerEmpty, validateTableInput } from 'utils/validation';
import { useAllowIncompleteAnswers } from 'utils/hooks/useTemplateConfigureParams';

export const useValidateTableInput = (
  question: IQuestion,
  context: FormikContextType<any>
) => {
  const { t } = useTranslation();
  const { isFormValid } = useSelector(
    (state: IRootReducerState) => state.formInfo
  );
  const [errorMessage, setErrorMessage] = useState<string>('');
  const allowIncompleteAnswers = useAllowIncompleteAnswers();

  useEffect(() => {
    const fieldValue = getIn(context.values, question.initialKey);
    const skipBecauseUnanswered =
      allowIncompleteAnswers && isAnswerEmpty(fieldValue);
    if (question.required && !skipBecauseUnanswered) {
      const fieldName = question.name;
      const error = validateTableInput(fieldValue, fieldName, t);

      if (error) {
        setErrorMessage(error);
        context.setFieldError(question.initialKey, error);
      } else {
        setErrorMessage('');
        context.setFieldError(question.initialKey, undefined);
      }
    } else {
      setErrorMessage('');
    }
  }, [
    getIn(context.values, question.initialKey),
    question.required,
    allowIncompleteAnswers,
  ]);

  useEffect(() => {
    if (errorMessage) {
      context.setFieldError(question.initialKey, errorMessage);
    } else {
      context.setFieldError(question.initialKey, undefined);
    }
  }, [errorMessage, isFormValid]);
  return errorMessage;
};
